import { Period } from "../../types";
import MaterialIcon from "../../components/MaterialIcon";
import Button from "../../components/Button";
import { RefObject, useRef } from "react";

interface PeriodListProps {
  periods: Period[];
  selectedPeriod: number | null;
  setSelectedPeriod: (period_id: number) => void;
  setEndPeriodModal: (b: boolean) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  recordTable: RefObject<HTMLTableElement>;
}

function PeriodList({
  periods,
  setSelectedPeriod,
  selectedPeriod,
  setEndPeriodModal,
  open,
  setOpen,
  recordTable,
}: PeriodListProps) {
  let containerRef = useRef<HTMLDivElement>(null);

  function handleContainerClick(e: React.MouseEvent<HTMLDivElement>) {
    if (e.target === containerRef.current) {
      setOpen(false);
    }
  }

  function handleCopyToClipboard() {
    console.log("Copying!");

    const table = recordTable.current;
    if (table === null) {
      return;
    }

    let textarea = document.createElement("textarea");
    textarea.value = table.innerHTML; // Use innerHTML to get the HTML content
    document.body.appendChild(textarea);

    // Select the content in the textarea
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length); // For mobile devices

    // Try to copy the text to the clipboard
    navigator.clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([table.outerHTML], { type: "text/html" }),
      }),
    ]);
  }

  return (
    <div
      className={`absolute left-0 top-0 h-full w-full lg:fixed lg:contents ${open ? "bg-black bg-opacity-75" : "bg-opacity-0"} ${open ? "visible" : "invisible"} transition-all lg:visible`}
      ref={containerRef}
      onClick={handleContainerClick}
    >
      <section
        className={`visible absolute inset-y-0 w-auto max-w-[90vw] lg:translate-x-0 ${open ? "translate-x-0" : "-translate-x-full"} border-grayscale-800 bg-grayscale-800 rounded-r-lg border-r-2 p-3 shadow transition-all lg:static lg:rounded-lg lg:border-none`}
      >
        <h2 className="px-4 text-center font-semibold">Periods</h2>
        {periods ? (
          <>
            <ul className="ml-3 list-disc">
              {periods.map((period, index) => (
                <li
                  key={period.id}
                  onClick={() => {
                    setSelectedPeriod(index);
                    setOpen(false);
                  }}
                  className={`hover:text-blu-200 cursor-pointer lg:text-nowrap ${index === selectedPeriod ? "underline" : ""}`}
                >
                  {period.name}
                </li>
              ))}
            </ul>
            <div className="mt-3 flex justify-center gap-2">
              <Button
                disabled={
                  periods && selectedPeriod && periods[selectedPeriod].end_date
                    ? true
                    : false
                }
                onClick={() => setEndPeriodModal(true)}
              >
                <MaterialIcon icon="event_busy" />
              </Button>
              <Button onClick={handleCopyToClipboard}>
                <MaterialIcon icon="output" />
              </Button>
            </div>
          </>
        ) : (
          <>
            <p>Loading...</p>
          </>
        )}
      </section>
    </div>
  );
}

export default PeriodList;
